export enum ExternalStoreType {
  STOREFARM = 'STOREFARM',
  FESTIVAL = 'FESTIVAL',
  PERFORM = 'PERFORM',
}

export enum ExternalExhibitType {
  MUSICAL = 'MUSICAL',
  CONCERT = 'CONCERT',
  DRAMA = 'DRAMA',
  CLASSIC = 'CLASSIC',
  EXHIBIT = 'EXHIBIT',
  KIDS = 'KIDS',
}

export enum ExternalAreaType {
  SE = 'SE',
  DH = 'DH',
  GG = 'GG',
  BS = 'BS',
  IC = 'IC',
  DJ = 'DJ',
  DG = 'DG',
  US = 'US',
  GJ = 'GJ',
  CC = 'CC',
  CCN = 'CCN',
  CCS = 'CCS',
  GS = 'GS',
  GSN = 'GSN',
  GSS = 'GSS',
  JL = 'JL',
  JLN = 'JLN',
  JLS = 'JLS',
  GW = 'GW',
  JJ = 'JJ',
  SJ = 'SJ',
  OS = 'OS',
  ET = 'ET',
}

export const getAreaText = (areaType: ExternalAreaType): string => {
  switch (areaType) {
    case ExternalAreaType.SE:
      return '서울'
    case ExternalAreaType.DH:
      return '대학로'
    case ExternalAreaType.GG:
      return '경기'
    case ExternalAreaType.BS:
      return '부산'
    case ExternalAreaType.IC:
      return '인천'
    case ExternalAreaType.DJ:
      return '대전'
    case ExternalAreaType.DG:
      return '대구'
    case ExternalAreaType.US:
      return '울산'
    case ExternalAreaType.GJ:
      return '광주'
    case ExternalAreaType.CC:
      return '충청'
    case ExternalAreaType.CCN:
      return '충북'
    case ExternalAreaType.CCS:
      return '충남'
    case ExternalAreaType.GSN:
      return '경상'
    case ExternalAreaType.GSS:
      return '경남'
    case ExternalAreaType.JL:
      return '전라'
    case ExternalAreaType.JLN:
      return '전북'
    case ExternalAreaType.JLS:
      return '전남'
    case ExternalAreaType.GW:
      return '강원'
    case ExternalAreaType.JJ:
      return '제주'
    case ExternalAreaType.SJ:
      return '세종'
    case ExternalAreaType.OS:
      return '해외'
    case ExternalAreaType.ET:
      return '다른지역'
  }
}
